// import React, { useEffect, useState } from "react";
// import { Link, useParams } from "react-router-dom";
// import { formatDate } from "../../helper/Helper";
// import Breadcrump from "../../components/Breadcrump";
// import blogAPI from "../../api/BlogApi";
// import SEO from "../../components/SEO";
// import BlogRelatedCard from "./relatedCard";
// import { Container } from "react-bootstrap";
// import {
//   FaFacebook,
//   FaInstagram,
//   FaTwitter,
//   FaYoutube,
//   FaLinkedin,
// } from "react-icons/fa";
// import { useSiteConfig } from "../../context/SiteConfigContext";

// function DetailPage() {
//   const { slug } = useParams();
//   const [item, setItem] = useState({});
//   const [relatedBlogs, setRelatedBlogs] = useState([]);
//   const [metaData, setMetaData] = useState({});
//   const { config } = useSiteConfig();

//   const fetchBlogsDetail = async () => {
//     try {
//       const res = await blogAPI.details(slug, { limit: 4 });
//       if (res.code === 200) {
//         const { blog, relatedBlogs } = res.data;
//         setItem(blog);
//         setRelatedBlogs(relatedBlogs || []);
//         setMetaData(blog?.meta || {});
//       }
//     } catch (err) {
//       console.error("Error loading blogs:", err);
//     }
//   };

//   const getInitials = (name) => {
//     if (!name) return "";
//     const words = name.trim().split(" ");
//     if (words.length === 1) return words[0].substring(0, 2).toUpperCase();
//     return (words[0][0] + words[words.length - 1][0]).toUpperCase();
//   };

//   useEffect(() => {
//     fetchBlogsDetail();
//   }, [slug]);

//   return (
//     <>
//       <Breadcrump title={item?.title} middle="" />
//       <SEO meta={metaData} />

//       <div className="blog-detail-clean">
//         <Container>
//           <div className="blog-detail-grid">
//             <main className="blog-detail-main">
//               <div className="blog-detail-header">
//                 <span className="blog-detail-kicker">Journal / Story</span>
//                 <h1 className="blog-detail-title">{item?.title}</h1>

//                 <div className="blog-detail-meta">
//                   <div className="blog-detail-author">
//                     <div className="blog-detail-avatar">
//                       {getInitials(item?.author)}
//                     </div>
//                     <div>
//                       <h6>{item?.author}</h6>
//                       <span>{formatDate(item?.date)}</span>
//                     </div>
//                   </div>
//                 </div>

//                 <p className="blog-detail-subtitle">{item?.shortDescription}</p>
//               </div>

//               <div className="blog-detail-image-wrap">
//                 <img
//                   src={item?.image}
//                   alt={item?.title}
//                   className="blog-detail-image"
//                 />
//               </div>

//               <div
//                 className="blog-detail-content"
//                 dangerouslySetInnerHTML={{ __html: item?.description }}
//               />
//             </main>

//             <aside className="blog-detail-sidebar">
//               <div className="blog-detail-sidebar-inner">
//                 <h2 className="blog-detail-sidebar-title">Related Blogs</h2>

//                 {relatedBlogs.length > 0 && (
//                   <div className="blog-detail-related-list">
//                     {relatedBlogs.map((blog, index) => (
//                       <div
//                         key={blog._id || index}
//                         className="blog-detail-related-item"
//                       >
//                         <BlogRelatedCard item={blog} />
//                       </div>
//                     ))}
//                   </div>
//                 )}

//                 <div className="blog-detail-viewall-wrap">
//                   <Link to="/blog" className="blog-detail-viewall">
//                     View All
//                   </Link>
//                 </div>
//               </div>
//             </aside>
//           </div>
//         </Container>
//       </div>
//     </>
//   );
// }

// export default DetailPage;



import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { formatDate } from "../../helper/Helper";
import Breadcrump from "../../components/Breadcrump";
import blogAPI from "../../api/BlogApi";
import SEO from "../../components/SEO";
import BlogRelatedCard from "./relatedCard";
import { Container } from "react-bootstrap";
import { useSiteConfig } from "../../context/SiteConfigContext";

function DetailPage() {
  const { slug } = useParams();
  const [item, setItem] = useState({});
  const [relatedBlogs, setRelatedBlogs] = useState([]);
  const [metaData, setMetaData] = useState({});
  const { config } = useSiteConfig();

  const fetchBlogsDetail = async () => {
    try {
      const res = await blogAPI.details(slug, { limit: 4 });
      if (res.code === 200) {
        const { blog, relatedBlogs } = res.data;
        setItem(blog);
        setRelatedBlogs(relatedBlogs || []);
        setMetaData(blog?.meta || {});
      }
    } catch (err) {
      console.error("Error loading blogs:", err);
    }
  };

  const getInitials = (name) => {
    if (!name) return "";
    const words = name.trim().split(" ");
    if (words.length === 1) return words[0].substring(0, 2).toUpperCase();
    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  };

  useEffect(() => {
    fetchBlogsDetail();
  }, [slug]);

  return (
    <>
      <style>{`
        @keyframes fadeInSlide {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in {
          animation: fadeInSlide 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
      `}</style>

      <div className="bg-[var(--color-bg)] min-h-screen text-[var(--color-text)] font-[family-name:var(--font-body)]">
        <Breadcrump title={item?.title} middle="" />
        <SEO meta={metaData} />

        <div className="py-[var(--spacing-xl)] lg:py-[var(--spacing-2xl)] animate-fade-in">
          <Container>
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-[var(--spacing-xl)] lg:gap-[var(--spacing-2xl)] items-start">
              
              {/* Main Content Area */}
              <main className="lg:col-span-8 flex flex-col gap-[var(--spacing-lg)]">
                
                {/* Header Info */}
                <div className="flex flex-col gap-[var(--spacing-sm)] border-b border-[var(--color-border)] pb-[var(--spacing-lg)]">
                  <span className="text-xs uppercase tracking-widest font-bold text-[var(--color-primary)] bg-[var(--color-bg-alt)] px-[var(--spacing-sm)] py-1 rounded-[var(--radius-sm)] w-fit">
                    Journal / Story
                  </span>
                  <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[var(--color-black)] leading-[var(--line-height-tight)]">
                    {item?.title}
                  </h1>

                  <div className="flex items-center justify-between flex-wrap gap-[var(--spacing-md)] pt-[var(--spacing-xs)]">
                    <div className="flex items-center gap-[var(--spacing-md)]">
                      <div className="w-12 h-12 rounded-[var(--radius-full)] bg-[var(--color-primary)] text-[var(--color-white)] flex items-center justify-center font-bold text-lg shadow-[var(--shadow-sm)]">
                        {getInitials(item?.author)}
                      </div>
                      <div>
                        <h6 className="font-bold text-[var(--color-black)] m-0 text-base">
                          {item?.author}
                        </h6>
                        <span className="text-sm text-[var(--color-text-muted)]">
                          {formatDate(item?.date)}
                        </span>
                      </div>
                    </div>
                  </div>

                  <p className="text-lg lg:text-xl text-[var(--color-text-muted)] font-normal leading-[var(--line-height-normal)] mt-[var(--spacing-xs)]">
                    {item?.shortDescription}
                  </p>
                </div>

                {/* Featured Image */}
                <div className="rounded-[var(--radius-lg)] overflow-hidden shadow-[var(--shadow-md)] bg-[var(--color-bg-alt)] border border-[var(--color-border)]">
                  <img
                    src={item?.image}
                    alt={item?.title}
                    className="w-full h-auto max-h-[500px] object-cover transition-transform duration-500 hover:scale-105"
                  />
                </div>

                {/* Rich Text Body Content */}
                <div
                  className="prose prose-lg max-w-none text-[var(--color-text)] leading-[var(--line-height-normal)] space-y-4 pt-[var(--spacing-sm)]
                    [&>h2]:text-2xl [&>h2]:font-bold [&>h2]:text-[var(--color-black)] [&>h2]:mt-6 [&>h2]:mb-3
                    [&>h3]:text-xl [&>h3]:font-bold [&>h3]:text-[var(--color-black)] [&>h3]:mt-5 [&>h3]:mb-2
                    [&>p]:mb-4 [&>ul]:list-disc [&>ul]:pl-5 [&>ol]:list-decimal [&>ol]:pl-5
                    [&>blockquote]:border-l-4 [&>blockquote]:border-[var(--color-primary)] [&>blockquote]:pl-4 [&>blockquote]:italic [&>blockquote]:text-[var(--color-text-muted)]"
                  dangerouslySetInnerHTML={{ __html: item?.description }}
                />
              </main>

              {/* Sidebar Area */}
              <aside className="lg:col-span-4 lg:sticky lg:top-24">
                <div className="bg-[var(--color-bg-alt)] rounded-[var(--radius-lg)] p-[var(--spacing-lg)] border border-[var(--color-border)] shadow-[var(--shadow-sm)] flex flex-col gap-[var(--spacing-lg)]">
                  <h2 className="text-2xl font-bold text-[var(--color-black)] border-b border-[var(--color-border)] pb-[var(--spacing-md)] m-0">
                    Related Blogs
                  </h2>

                  {relatedBlogs.length > 0 ? (
                    <div className="flex flex-col gap-[var(--spacing-md)]">
                      {relatedBlogs.map((blog, index) => (
                        <div
                          key={blog._id || index}
                          className="transition-all duration-300 hover:translate-x-1"
                        >
                          <BlogRelatedCard item={blog} />
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="text-sm text-[var(--color-text-muted)] italic">
                      No related blogs available.
                    </p>
                  )}

                  <div className="pt-[var(--spacing-sm)] border-t border-[var(--color-border)] text-center">
                    <Link
                      to="/blog"
                      className="inline-block w-full py-3 px-6 rounded-[var(--radius-md)] bg-[var(--color-primary)] text-[var(--color-white)] font-bold text-center shadow-[var(--shadow-sm)] transition-all duration-300 hover:bg-[var(--color-primary-dark)] hover:shadow-[var(--shadow-md)]"
                    >
                      View All Blogs
                    </Link>
                  </div>
                </div>
              </aside>

            </div>
          </Container>
        </div>
      </div>
    </>
  );
}

export default DetailPage;
